<template>
  <div class="appds">
    <div class="app-web contain-box">
      <div class="head">
        <div class="contain-box head-box fl-sb-ce">
          <div class="headicon">
            <img src="@/assets/img/headicon.png" alt="" class="headimg" />
          </div>
          <div class="menu-icon" @click="drawer = true">
            <img src="@/assets/img/menu-icon.png" alt="" class="" />
          </div>
        </div>
      </div>
      <div
        class="scroll-content"
        :style="{ height: contentStyleObj.height }"
        @scroll="onScroll"
      >
        <!-- 首页 -->
        <div :ref="tabs[0].refName" class="scroll-item">
          <div class="block">
            <img src="@/assets/img/one_.png" alt="" class="imgs" />
          </div>
        </div>
        <!-- 平台介绍 -->
        <div :ref="tabs[1].refName" class="scroll-item">
          <div class="block">
            <img src="@/assets/img/two_.png" alt="" class="imgs" />
          </div>
          <div class="block">
            <img src="@/assets/img/three_.png" alt="" class="imgs" />
          </div>
          <div class="block">
            <img src="@/assets/img/four_.png" alt="" class="imgs" />
          </div>
        </div>
        <!-- 项目解决方案 -->
        <div :ref="tabs[2].refName" class="scroll-item">
          <div class="block">
            <img src="@/assets/img/five_.png" alt="" class="imgs" />
          </div>
          <div class="block">
            <img src="@/assets/img/six_.png" alt="" class="imgs" />
          </div>
          <div class="block">
            <img src="@/assets/img/seven_.png" alt="" class="imgs" />
          </div>
          <div class="block">
            <img src="@/assets/img/eight_.png" alt="" class="imgs" />
          </div>
          <div class="block">
            <img src="@/assets/img/nine_.png" alt="" class="imgs" />
          </div>
          <div class="block">
            <img src="@/assets/img/ten_.png" alt="" class="imgs" />
          </div>
        </div>
        <!-- 联系我们 -->
        <div :ref="tabs[3].refName" class="scroll-item">
          <div class="block">
            <img :src="ImgSrc('eleven_.png')" alt="" class="imgs" />
          </div>
          <div class="block setals">
            <div>
              <div class="fxtest">
                <span class="xiatext" @click="openNew">
                  蜀ICP备20001411号-6</span
                >
              </div>
              <div class="fxtest">
                <div style="cursor: pointer" @click="openNew">
                  <span>Copyright ©2023 四川神鸟世纪科技有限公司</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <el-drawer :visible.sync="drawer" :with-header="false" size="75%">
        <div class="drawer-box">
          <div class="tab-box">
            <div
              v-for="(item, index) in tabs"
              :key="index"
              @click="jump(index)"
              :class="[tabIndex == index ? 'active' : '', 'tab-item']"
            >
              {{ item.title }}
            </div>
          </div>
          <div class="line"></div>
          <div class="phone-box" @click="call">
            <img
              class="phone-img"
              src="@/assets/img/icon/Telephone.png"
              alt=""
            />
            <div>质量投诉电话</div>
            <div class="phone-num">{{ phoneNumber }}</div>
          </div>
        </div>
      </el-drawer>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tabIndex: 0,
      contentStyleObj: {
        height: "0",
      },
      scrollTop: 0,
      tabs: [
        {
          isShow: true,
          title: "首页",
          refName: "Homepage",
        },
        {
          isShow: true,
          title: "平台介绍",
          refName: "Platform",
        },
        {
          isShow: true,
          title: "项目解决方案",
          refName: "Mainpro",
        },
        {
          isShow: true,
          title: "联系我们",
          refName: "Contactus",
        },
      ],
      drawer: false,
      phoneNumber: "028-62325607",
    };
  },
  created() {
    this.getDevice();
    window.addEventListener("resize", this.getDevice);
  },
  destroyed() {
    window.removeEventListener("resize", this.getDevice);
  },
  methods: {
    openNew() {
      window.open("https://beian.miit.gov.cn/");
    },
    // tab click
    jump(index) {
      this.drawer = false;
      let target = document.querySelector(".scroll-content");
      let scrollItems = document.querySelectorAll(".scroll-item");
      // 判断滚动条是否滚动到底部
      if (target.scrollHeight <= target.scrollTop + target.clientHeight) {
        this.tabIndex = index;
      }
      let totalY = scrollItems[index].offsetTop - scrollItems[0].offsetTop; // 锚点元素距离其offsetParent(这里是body)顶部的距离(待滚动的距离)
      let distance = document.querySelector(".scroll-content").scrollTop; // 滚动条距离滚动区域顶部的距离
      // let distance = document.body.scrollTop || document.documentElement.scrollTop || window.pageYOffset // 滚动条距离滚动区域顶部的距离(滚动区域为窗口)
      // 滚动动画实现, 使用setTimeout的递归实现平滑滚动，将距离细分为50小段，10ms滚动一次
      // 计算每一小段的距离
      let step = totalY / 50;
      if (totalY > distance) {
        smoothDown(document.querySelector(".scroll-content"));
      } else {
        let newTotal = distance - totalY;
        step = newTotal / 50;
        smoothUp(document.querySelector(".scroll-content"));
      }
      // 参数element为滚动区域
      function smoothDown(element) {
        if (distance < totalY) {
          distance += step;
          element.scrollTop = distance;
          setTimeout(smoothDown.bind(this, element), 10);
        } else {
          element.scrollTop = totalY;
        }
      }
      // 参数element为滚动区域
      function smoothUp(element) {
        if (distance > totalY) {
          distance -= step;
          element.scrollTop = distance;
          setTimeout(smoothUp.bind(this, element), 10);
        } else {
          element.scrollTop = totalY;
        }
      }
    },
    // 滚动条滚动
    onScroll(e) {
      this.scrollTop = e.target.scrollTop;
      let scrollItems = document.querySelectorAll(".scroll-item");
      for (let i = scrollItems.length - 1; i >= 0; i--) {
        // 判断滚动条滚动距离是否大于当前滚动项可滚动距离
        let judge =
          e.target.scrollTop >=
          scrollItems[i].offsetTop - scrollItems[0].offsetTop - 400;
        if (judge) {
          this.tabIndex = i;
          break;
        }
      }
    },
    // 获取浏览器宽高
    getDevice() {
      this.contentStyleObj.height = window.innerHeight - 48 + "px";
    },
    call() {
      window.location.href = `tel:${this.phoneNumber}`;
    },
  },
};
</script>
<style lang="scss" scoped>
.appds {
  display: flex;
  justify-content: center;
}
.app-web {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: auto;
  .head {
    height: 48rem;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background: transparent;
    position: sticky;
    top: 0px;
    z-index: 100;
    background: #fff;
    border-bottom: 1rem solid #f2f3f5;

    .headicon {
      display: flex;
      align-items: center;
      text-align: center;

      .headimg {
        width: 82rem;
        height: auto;
      }
    }
    .menu-icon {
      img {
        width: 24rem;
        height: auto;
      }
    }
    .tabsd {
      display: flex;
      align-items: center;
    }
  }
  .scroll-content {
    width: 100%;
    overflow-x: hidden;
    overflow-y: auto;
  }
  .footer {
    width: 100%;
  }
}
.scroll-item {
  width: 100%;
  .block {
    width: 100%;
    height: auto;
    display: flex;
    justify-content: center;
    .imgs {
      width: 100%;
      height: 100%;
    }
  }
}
.setals {
  background: rgb(245, 248, 250);
  text-align: center;
  font-size: 14rem;
  color: #4e5766;
  padding: 20rem 0;
  line-height: 30rem;
}
.xiatext {
  text-decoration: underline;
  cursor: pointer;
}
.fxtest {
  display: flex;
  align-items: center;
  justify-content: center;
}
.drawer-box {
  padding: 36.66rem 33.33rem;
  .tab-item {
    color: #1d2129;
    font-size: 18rem;
    font-weight: 600;
    line-height: 22rem;
    margin-bottom: 24rem;
  }
  .line {
    width: 100%;
    height: 1rem;
    background: #f2f3f5;
    margin: 33.33rem 0;
  }
  .phone-box {
    color: #86909c;
    font-size: 14rem;
    line-height: 24rem;
    .phone-img {
      width: 21rem;
      height: auto;
      margin-bottom: 7rem;
    }
    .phone-num {
      color: #4e5969;
      font-size: 18rem;
      font-weight: 600;
      line-height: 24rem;
      margin-top: 5rem;
    }
  }
  .active {
    color: #1f71ff;
  }
}
</style>
